import { Clinic } from '@dataTypes/location.type'

export const MOCK_CLINICS: Clinic[] = [
  {
    clinic_id: 'c35b9d87-7135-4b08-9d04-18c41cd91e8a',
    clinic_name: 'Bright Smiles Dental',
    phone_number: '+15550000001',
    address: '100 Mock St, New York, NY 10001',
    image: '',
    about: 'Development-only mock clinic.',
    same_working_hours: true,
    working_hours: {
      monday: { is_open: true, start: '09:00', end: '17:00' },
      tuesday: { is_open: true, start: '09:00', end: '17:00' },
      wednesday: { is_open: true, start: '09:00', end: '17:00' },
      thursday: { is_open: true, start: '09:00', end: '17:00' },
      friday: { is_open: true, start: '09:00', end: '17:00' },
      saturday: { is_open: false, start: null, end: null },
      sunday: { is_open: false, start: null, end: null },
    },
    coordinates: { lat: 40.748817, lng: -73.985428 },
    disabled: false,
  },
  {
    clinic_id: 'ed6ea79f-f56b-49a3-af58-34bb3084aca0',
    clinic_name: 'Happy Teeth Clinic',
    phone_number: '+15550000002',
    address: '200 Mock Ave, Los Angeles, CA 90001',
    image: '',
    about: 'Development-only mock clinic.',
    same_working_hours: true,
    working_hours: {
      monday: { is_open: true, start: '08:00', end: '16:00' },
      tuesday: { is_open: true, start: '08:00', end: '16:00' },
      wednesday: { is_open: true, start: '08:00', end: '16:00' },
      thursday: { is_open: true, start: '08:00', end: '16:00' },
      friday: { is_open: true, start: '08:00', end: '16:00' },
      saturday: { is_open: false, start: null, end: null },
      sunday: { is_open: false, start: null, end: null },
    },
    coordinates: { lat: 34.052235, lng: -118.243683 },
    disabled: false,
  },
]
